 
const mutations = {
  SET_HISTORICAL_DISTRIBUTIONS(state, payload) {
    state.historicalDistributionsData = { ...payload };
  }
};

const getters = {
  historicalDistributionsData: state => state.historicalDistributionsData
};

const state = {
  historicalDistributionsData: null
};

export default {
  state,
  getters,
  mutations
};
